import { PermissionCodes } from "@/constants/permissionCodes";
import { isBigCompanyByOrg } from "@/utils/gaodingVip";
import { usePermission } from "@/utils/hooks/usePermisson";

import useAppStore from "@/context/store";
import { getDeliveryDetail } from "@/services/qingzhou";
import React, { useEffect, useState } from "react";
import styles from "./MembershipDropdown.module.less";

interface MembershipDropdownProps {
  className?: string;
}

const MembershipDropdown: React.FC<MembershipDropdownProps> = () => {
  const user = useAppStore((state) => state.user);
  const orgInfo = useAppStore((state) => state.orgInfo);
  const [config, setConfig] = useState<any>(null);

  const hasOfficialWebNavigationPermission = usePermission(
    PermissionCodes.officialWebNavigation
  );

  useEffect(() => {
    const fetchConfig = async () => {
      const dropdownResult = await getDeliveryDetail(
        "framework_v2--vip_entrance"
      );

      const dropdownConfig = dropdownResult?.pit_modules?.[0]?.material;

      if (dropdownConfig) setConfig(dropdownConfig);
    };
    fetchConfig();
  }, [user]);

  // 配置为空时不展示
  if (!config) return null;

  // 企业版不展示
  if (isBigCompanyByOrg(orgInfo?.org)) return null;

  // 没登录或权限点判断没有权限时不展示
  if (!user || !hasOfficialWebNavigationPermission) return null;

  // 全量采用string_2实验组2：只显示角标，不包装Dropdown
  return (
    <a
      href={config.page_link || "#buyVip"}
      target={config.page_link ? "_blank" : "_self"}
    >
      <button
        className={styles.triggerButton}
        style={{ padding: 0, border: "none", background: "transparent" }}
        data-gd-expose="button_expose"
        data-gd-click="button_click"
        data-button-name="订购会员"
        data-subject-name="按钮"
        data-module-name="顶部导航栏"
      >
        {(config.img_url || config.img_url2) && (
          <img
            src={config.img_url || config.img_url2}
            alt="订购会员"
            className={styles.triggerImg}
          />
        )}
      </button>
    </a>
  );
};

export default MembershipDropdown;
